export default __webpack_public_path__ + "static/media/bus.d2eb7e2f.jpg";